import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';

import { DialogModule } from 'primeng/dialog';

import { CookiesDialogComponent } from './cookies-dialog.component';

@NgModule({
	declarations: [CookiesDialogComponent],
	imports: [CommonModule, DialogModule, RouterModule, BrowserModule],
	exports: [CookiesDialogComponent],
})
export class CookiesDialogModule {}
